/* -------------------------------------------------------------------------- */
/*                               Project types                                */
/* -------------------------------------------------------------------------- */

import { CURRENCY_UNITS } from '@config/constants/currency-units';

/**
 * Retrieves the label associated with the specified currency ID.
 * @param {string} id - The ID of the currency to retrieve the label for.
 * @returns {string|null} The label of the currency, or null if the currency is not found.
 */
export const getCurrencyUnit = (id: string) => {
	const foundUnit = CURRENCY_UNITS.find(
		(currency) => currency.id === id
	);
	return (foundUnit && foundUnit.label) || '';
};
